/* unplugin-vue-components disabled */import { render } from "./Footer.vue?vue&type=template&id=b9607170&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=b9607170&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9607170"]])

export default __exports__